export interface SubscriberGroup {
  name: string;
  id?: number;
  subscriberCount?: number;
  groups?: Array<SubscriberGroup>;
  totalPercentage?: number;
  conversionRate?: number;
}
